import Forum from "./components";
export default Forum;